import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    standalone: false,
    selector: 'lib-app-streams-toolbar',
  templateUrl: './streams-toolbar.component.html',
  styleUrls: ['./streams-toolbar.component.scss']
})
export class StreamsToolbarComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit() {
  }
}
